import { createContext } from 'react';

export type HotelConfigContextValue = {
  hotelIndex?: number;
};

export const HotelConfigContext = createContext<HotelConfigContextValue>({
  hotelIndex: undefined,
});

export default HotelConfigContext;
